import React from 'react'

import { Buttons } from './styles'

interface Props {
  type: 'primary' | 'secondary'
  children: unknown
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any
}

const Button = ({ children, type, ...rest }: Props) => (
  <Buttons {...rest} model={type}>
    {typeof children === 'string' ? (
      <span className={type}>{children}</span>
    ) : (
      children
    )}
  </Buttons>
)

export default Button
